/**
 * Consulta de CEP via ViaCEP (API pública gratuita). Usada para autofill do
 * endereço estruturado do cliente. Só roda online; qualquer falha retorna null
 * e o usuário preenche manualmente. Traz o código IBGE do município (cMun da
 * NF-e), essencial para o endereço do destinatário.
 */
export interface CepAddress {
  cep: string;          // só dígitos
  logradouro: string;
  bairro: string;
  municipioNome: string;
  uf: string;
  municipioIbge: string;
  complemento: string;
}

export async function lookupCep(cep: string): Promise<CepAddress | null> {
  const d = (cep ?? '').replace(/\D/g, '');
  if (d.length !== 8) return null;
  try {
    const res = await fetch(`https://viacep.com.br/ws/${d}/json/`);
    if (!res.ok) return null;
    const data = await res.json();
    if (!data || data.erro) return null;
    return {
      cep: d,
      logradouro: data.logradouro || '',
      bairro: data.bairro || '',
      municipioNome: data.localidade || '',
      uf: data.uf || '',
      municipioIbge: data.ibge || '',
      complemento: data.complemento || '',
    };
  } catch {
    return null;
  }
}
